import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../../Assets/javascripts/common/others/SharedDispatcher";

var ACTIVE_CLASS = "TabbedListItem--active"

    export default Backbone.View.extend({
        initialize: function () {
            this.$controls = this.$(".js-TabbedList-control")
            this.$contents = this.$(".js-TabbedList-content")

            this.index = 1
            this.lastIndex = null

            this.listenTo(SharedDispatcher, "tabbedlist:show", this.show)
        },

        events: {
            "click .js-TabbedList-control": "clickShow"
        },

        clickShow: function (e) {
            this.lastIndex = this.index
            this.index = $(e.currentTarget).attr("data-id")

            this.render()
        },

        show: function (options) {
            this.lastIndex = this.index
            this.index = options.index

            this.render()
        },

        setIndex: function (index) {
            this.index = index
        },

        render: function () {
            $(this.$controls).removeClass(ACTIVE_CLASS)
            $(this.$contents).removeClass(ACTIVE_CLASS)


            $(this.$controls[this.index - 1]).addClass(ACTIVE_CLASS)
            $(this.$contents[this.index - 1]).addClass(ACTIVE_CLASS)
        }
    })
